import PropTypes from 'prop-types';
import React from 'react';
import { safeJSONParse } from 'helpers/sf_utils';
import { Col, Row, FormGroup } from 'reactstrap';
import DefaultComponent from './DefaultComponent';

/**
 * InputComponent is a reusable React component that renders a form component field with an associated label and tooltip.
 * 
 * @param {Object} props - The props for the InputComponent.
 * @param {Object} props.label - An object containing properties related to the label.
 * @param {string} props.label.name - The name of the label.
 * @param {string} props.label.tooltip - The tooltip message for the label.
 * @param {Object} props.component - An object containing properties related to the component field.
 * @param {string} props.component.id - The ID of the component field.
 * @param {string} props.component.name - The name of the component field.
 * @param {string} props.component.type - The type of the component field (default is 'text').
 * @param {Object} props.validation - An object containing form validation properties.
 * @param {Function} props.validation.handleChange - The function to handle component changes.
 * @param {Function} props.validation.handleBlur - The function to handle component blur.
 * @param {Object} props.validation.values - An object containing form values.
 * @param {Object} props.validation.touched - An object indicating whether fields have been touched.
 * @param {Object} props.validation.errors - An object containing validation errors.
 * 
 * @returns {JSX.Element} - A React component that renders an component field with label and tooltip.
 */
const SelectWithDisplay = ({ index, question, onChangeEvent }) => {
    const question_drop_down_values = safeJSONParse(question?.drop_down_values, [])
    return (
        <Row>
            <Col md={12}>
                <div className="quote-funnel-checkbox-content-container mb-3">
                    {(question_drop_down_values?.display_arr || []).map((item, idx) => (
                        <div key={idx} className={idx % 2 !== 0 ? 'quote-funnel-checkbox-right-content mb-2' : 'quote-funnel-checkbox-left-content mb-2'}>
                            <FormGroup check className='d-flex align-items-center'>
                                <i className="bx bxs-circle"></i>
                                <h5 className="ms-2 text-black b-0 m-0">{item}</h5>
                            </FormGroup>
                        </div>
                    ))}
                </div>

            </Col>

            <Col md={12}>
                <DefaultComponent index={index} question={{ ...question, drop_down_values: JSON.stringify(question_drop_down_values?.options || []) }} onChangeEvent={onChangeEvent} />
            </Col>
        </Row>
    );
}

SelectWithDisplay.propTypes = {
    label: PropTypes.object,
    component: PropTypes.object,
    validation: PropTypes.object,
};

export default SelectWithDisplay;
